import { ActionButton, Chip, OptionButton } from '../../../parts/index.js';

const sentence = (words: string) => /[.!?]$/.test(words) ? words : `${words}.`;

export function Loading({ reading, drawing = false }: { reading: string; drawing?: boolean }) {
  if (drawing) return <div className="state" role="status" aria-label="Loading"><div className="skel" aria-hidden="true" style={{ width: '40%' }} /><div className="skel" aria-hidden="true" style={{ width: '85%' }} /><p className="note">{reading.startsWith('Checking ') ? reading : `Reading ${reading}`}</p></div>;
  return <div className="admin-master-state" role="status">
    <div className="admin-master-skeleton" aria-hidden="true" />
    <div className="admin-master-skeleton" aria-hidden="true" />
    <p>{reading.startsWith('Checking ') ? reading : `Reading ${reading}`}</p>
  </div>;
}

export function CouldNotLoad({ what, at, onRetry, drawing = false }: { what: string; at?: string; onRetry: () => void; drawing?: boolean }) {
  if (drawing) return <div className="state"><div className="err" role="alert">{what} could not be read.{at ? ` This is from ${at}.` : ''}</div><div className="opts"><ActionButton reading className="opt" onClick={onRetry}>Try again</ActionButton></div></div>;
  return <div className="admin-master-state admin-master-error" role="alert">
    <p>{what} could not be read.{at ? ` This is from ${at}.` : ''}</p>
    <OptionButton opensOnly onClick={onRetry}>Try again</OptionButton>
  </div>;
}

export function Saved({ what, takeBackUntil, takeBackNote, onTakeBack, drawing = false, line = false }: { line?: boolean; what: string; takeBackUntil?: string; takeBackNote?: string; onTakeBack?: () => void; drawing?: boolean }) {
  if (line) return <p className="saved" role="status">{sentence(what)}{takeBackUntil ? ` You can take it back until ${takeBackUntil}.` : ''}</p>;
  if (drawing) return <div className="state"><p className="sec">A change, just made</p><div className="toastx" role="status">{sentence(what)}{takeBackUntil ? ` You can take it back until ${takeBackUntil}.` : takeBackNote ? ` ${takeBackNote}` : ''}{takeBackUntil && onTakeBack ? <> <ActionButton className="textbtn" onClick={onTakeBack}>Take it back</ActionButton></> : null}</div></div>;
  return <div className="admin-master-state admin-master-saved" role="status">
    <p>{sentence(what)}{takeBackUntil ? ` You can take it back until ${takeBackUntil}.` : takeBackNote ? ` ${takeBackNote}` : ''}</p>
    {takeBackUntil && onTakeBack ? <OptionButton onClick={onTakeBack}>Take it back</OptionButton> : null}
  </div>;
}

export function Refused({ words, drawing = false }: { words: string; drawing?: boolean }) {
  if (drawing) return <div className="state"><p className="err" role="alert">{words}</p></div>;
  return <p className="admin-master-state admin-master-error" role="alert">{words}</p>;
}

export function NotSaved({ reason, onRetry, drawing = false }: { reason: string; onRetry: () => void; drawing?: boolean }) {
  if (drawing) return <div className="state" role="alert"><span className="chip">Not saved yet</span><div className="err">It was not saved: {sentence(reason)}</div><div className="opts"><ActionButton className="opt" onClick={onRetry}>Try again</ActionButton></div></div>;
  return <div className="admin-master-state admin-master-error" role="alert">
    <Chip>Not saved yet</Chip>
    <p>It was not saved: {sentence(reason)}</p>
    <OptionButton onClick={onRetry}>Try again</OptionButton>
  </div>;
}
